export var rentalPrice = {
  name: 'rentalPrice',
  type: 'integer',
  format: 'currency',
  minimum: 1,
  maximum: 10000000
};
export var monthlyRent = {
  name: 'monthlyRent',
  type: 'integer',
  format: 'currency',
  minimum: 1,
  maximum: 10000000
};
export var propertyTaxRate = {
  name: 'propertyTaxRate',
  type: 'float',
  format: 'percentage',
  minimum: 0,
  maximum: 1
};
export var HOADues = {
  name: 'HOADues',
  type: 'integer',
  format: 'currency',
  minimum: 0,
  maximum: 10000000
};
export var monthlyHoa = {
  name: 'monthlyHoa',
  type: 'integer',
  format: 'currency',
  minimum: 0,
  maximum: 10000000
};
export var homeInsurance = {
  name: 'homeInsurance',
  type: 'float',
  format: 'percentage',
  minimum: 0,
  maximum: 1
};
export var maintainanceFees = {
  name: 'maintainanceFees',
  type: 'float',
  format: 'percentage',
  minimum: 0,
  maximum: 1
};
export var renovationFees = {
  name: 'renovationFees',
  type: 'float',
  format: 'percentage',
  minimum: 0,
  maximum: 1
};
export var incomeTaxRate = {
  name: 'incomeTaxRate',
  type: 'float',
  format: 'percentage',
  minimum: 0,
  maximum: 1
};
export var rentersInsurance = {
  name: 'rentersInsurance',
  type: 'float',
  format: 'percentage',
  minimum: 0,
  maximum: 1
};
export var buyingCosts = {
  name: 'buyingCosts',
  type: 'float',
  format: 'percentage',
  minimum: 0,
  maximum: 1
};
export var sellingCosts = {
  name: 'sellingCosts',
  type: 'float',
  format: 'percentage',
  minimum: 0,
  maximum: 1
};
export var rentSecurityDeposit = {
  name: 'rentSecurityDeposit',
  type: 'integer',
  format: 'currency',
  minimum: 0,
  maximum: 10000000
};
export var homeAppreciation = {
  name: 'homeAppreciation',
  type: 'float',
  format: 'percentage',
  minimum: 0,
  maximum: 1
};
export var homeValueAppreciation = {
  name: 'homeValueAppreciation',
  type: 'float',
  format: 'percentage',
  minimum: 0,
  maximum: 1
};
export var rentAppreciation = {
  name: 'rentAppreciation',
  type: 'float',
  format: 'percentage',
  minimum: 0,
  maximum: 1
};
export var inflationRate = {
  name: 'inflationRate',
  type: 'float',
  format: 'percentage',
  minimum: 0,
  maximum: 1
};
export var discountRate = {
  name: 'discountRate',
  type: 'float',
  format: 'percentage',
  minimum: 0,
  maximum: 1
};
export var generalInflation = {
  name: 'generalInflation',
  type: 'float',
  format: 'percentage',
  minimum: 0,
  maximum: 1
};
export var annualReturnCash = {
  name: 'annualReturnCash',
  type: 'float',
  format: 'percentage',
  minimum: 0,
  maximum: 1
};
export var taxStatus = {
  name: 'taxStatus',
  type: 'array',
  whitelist: ['individual', 'joint']
};
export var taxFilingStatus = {
  name: 'taxFilingStatus',
  type: 'string',
  whitelist: ['individual', 'joint']
};
export var householdIncome = {
  name: 'householdIncome',
  type: 'integer',
  format: 'currency',
  minimum: 0,
  maximum: 10000000
};
export var income = {
  name: 'income',
  type: 'integer',
  format: 'currency',
  minimum: 0,
  maximum: 10000000
};
export var capitalGainsTaxRate = {
  name: 'capitalGainsTaxRate',
  type: 'float',
  format: 'percentage',
  minimum: 0,
  maximum: 1
};
export var howLongStay = {
  name: 'howLongStay',
  type: 'integer',
  minimum: 0,
  maximum: 30
};